export default "__VITE_ASSET__DrH4z5qi__"